import settingsStorybookEntryRegistry from '../../../../config/settings-intent/ystnj-settings-storybook-entry-system-v1.json';

export type StaffSettingsSection =
  | 'general'
  | 'users'
  | 'admissions'
  | 'financial-aid';

export type LegacySettingsSection = StaffSettingsSection;

type SettingsStorybookEntry = {
  id: string;
  storyId: string;
  sectionKey: string;
  route: string;
  routeHints: string[];
  rootTestId: string;
  visualSurfaceTestId: string;
  tabLabel: string;
  surfaceTitle: string;
  surfaceDescription: string;
  journeyIds: string[];
  personaHints: string[];
  annotationRefs: string[];
  policyIntentRefs: string[];
  designSystemProfiles: string[];
  verificationRefs: string[];
  tempPageCapability: boolean;
  hrmSubject: string;
  includeInJourneyMatching: boolean;
};

type RegistryPayload = {
  storyEntries: SettingsStorybookEntry[];
};

const registry = settingsStorybookEntryRegistry as RegistryPayload;

export const SETTINGS_STORYBOOK_ENTRIES = registry.storyEntries;

const STAFF_ADMIN_ENTRY_BY_SECTION = new Map<StaffSettingsSection, SettingsStorybookEntry>(
  SETTINGS_STORYBOOK_ENTRIES
    .filter(
      (entry) =>
        entry.personaHints.length === 0
        && entry.includeInJourneyMatching !== false
        && ['general', 'users', 'admissions', 'financial-aid'].includes(entry.sectionKey),
    )
    .map((entry) => [entry.sectionKey as StaffSettingsSection, entry]),
);

export const STAFF_SETTINGS_SECTION_ORDER: readonly StaffSettingsSection[] = [
  'general',
  'users',
  'admissions',
  'financial-aid',
] as const;

export const getSettingsStorybookEntry = (id: string): SettingsStorybookEntry => {
  const entry = SETTINGS_STORYBOOK_ENTRIES.find((candidate) => candidate.id === id);
  if (!entry) {
    throw new Error(`Unknown settings Storybook entry id: ${id}`);
  }
  return entry;
};

export const getStaffSettingsSectionEntry = (section: StaffSettingsSection): SettingsStorybookEntry => {
  const entry = STAFF_ADMIN_ENTRY_BY_SECTION.get(section);
  if (!entry) {
    throw new Error(`Missing staff settings Storybook entry for section: ${section}`);
  }
  return entry;
};

export const getLegacySettingsSectionEntry = (section: LegacySettingsSection): SettingsStorybookEntry =>
  getStaffSettingsSectionEntry(section);

export const getStaffSettingsSectionRoute = (section: StaffSettingsSection): string =>
  getStaffSettingsSectionEntry(section).route;
